import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

export const CpEmptyStateWrapper = styled.div`
  display: flex;
  height: 200px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Default-Coolest-Gray-10, #f9f9fa);
`;

export const CpEmptyStateText = styled.div`
  color: var(--Text-text-placeholder, rgba(0, 0, 0, 0.35));
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.15px;
`;

export const CpFormEmptyState = () => {
  return (
    <CpEmptyStateWrapper>
      <CpEmptyStateText data-cy="cp.project-forms-empty-state">
        <FormattedMessage id="project.forms.empty_state.message" />
      </CpEmptyStateText>
    </CpEmptyStateWrapper>
  );
};
